import { createSlice } from "@reduxjs/toolkit";

export const marginAnalysisSlice = createSlice({
    name: 'marginAnalysisState',
    initialState: {
        filters: {
            clientId: {value: null},
            lotId: {value: null},
            activityDate: {value: null},
        }
    },
    reducers: {
        setFilters: (state, action) => {
            state.filters = action.payload;
        }
    },
});

export const { setFilters } = marginAnalysisSlice.actions;
export default marginAnalysisSlice.reducer;